module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "streams-container",
    class: {
      'expanded-view': _vm.isAnyStreamExpanded
    }
  }, _vm._l((_vm.peers), function(peer) {
    return _c('stream', {
      key: peer.identifier,
      class: _vm.videoDisplayClass(peer.identifier),
      attrs: {
        "source": peer.stream,
        "screen-source": peer.screenStream,
        "is-local-stream": false,
        "label": peer.name,
        "id": peer.identifier,
        "peer": peer
      },
      nativeOn: {
        "click": function($event) {
          _vm.expandStream(peer.identifier)
        }
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00f5ebb8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Participants.vue
// module id = 360
// module chunks = 1